export default (state, action) => {
  const { containerCount, itemCount } = state;
  const { originalId, copyId, containerMap } = action.payload;

  const prevContainerCount = containerCount[originalId];
  const updatedContCount = {
    ...containerCount,
    [copyId]: prevContainerCount,
  };

  const originalContainers = Object.keys(containerMap);
  const updatedItemCount = {
    ...itemCount,
  };

  let newContainerId;
  originalContainers.forEach((givenId) => {
    newContainerId = containerMap[givenId];
    updatedItemCount[newContainerId] = itemCount[givenId];
  });

  return {
    ...state,
    containerCount: updatedContCount,
    itemCount: updatedItemCount,
  };
};
